const GUEST_CODE_PATTERN = /^[A-Za-z0-9]{6,9}$/;

const getFallbackOrigin = () => (
  typeof window !== 'undefined' ? window.location.origin : 'https://qrmaps.me'
);

export const normalizeGuestCruiseCode = (value) => {
  const code = String(value || '').trim();
  return GUEST_CODE_PATTERN.test(code) ? code : null;
};

export const getGuestCruiseCodeFromLocation = (locationLike = null) => {
  if (typeof window === 'undefined' && !locationLike) return null;

  let url;
  try {
    if (locationLike instanceof URL) {
      url = locationLike;
    } else if (typeof locationLike === 'string') {
      url = new URL(locationLike, getFallbackOrigin());
    } else {
      url = new URL(window.location.href);
    }
  } catch (_error) {
    return null;
  }

  const queryCode = normalizeGuestCruiseCode(url.searchParams.get('code'));
  if (queryCode) return queryCode;
  if (url.pathname.endsWith('/guest.html')) return null;

  const [firstSegment] = url.pathname.split('/').filter(Boolean);
  return normalizeGuestCruiseCode(firstSegment);
};

export const addCruiseContextToMapUrl = (mapUrl, guestCode = null) => {
  if (!mapUrl) return null;
  const cruiseCode = normalizeGuestCruiseCode(guestCode) || getGuestCruiseCodeFromLocation();
  if (!cruiseCode) return mapUrl;

  try {
    const url = new URL(mapUrl, getFallbackOrigin());
    url.searchParams.set('cruise_context', cruiseCode);
    return url.toString();
  } catch (_error) {
    return mapUrl;
  }
};

export const getCruiseContextFromLocation = (locationLike = null) => {
  if (typeof window === 'undefined' && !locationLike) return null;
  try {
    const url = locationLike instanceof URL
      ? locationLike
      : new URL(locationLike || window.location.href, getFallbackOrigin());
    return normalizeGuestCruiseCode(url.searchParams.get('cruise_context'));
  } catch (_error) {
    return null;
  }
};

export const buildCruiseOverviewUrl = (guestCode, locationLike = null) => {
  const cruiseCode = normalizeGuestCruiseCode(guestCode);
  if (!cruiseCode) return null;

  let url;
  try {
    url = locationLike instanceof URL
      ? locationLike
      : new URL(locationLike || window.location.href, getFallbackOrigin());
  } catch (_error) {
    return `/${encodeURIComponent(cruiseCode)}`;
  }

  if (url.pathname.endsWith('/guest.html') || import.meta.env.DEV) {
    return `${url.origin}/guest.html?code=${encodeURIComponent(cruiseCode)}`;
  }
  return `${url.origin}/${encodeURIComponent(cruiseCode)}`;
};
